export enum EQrCodeKind {
  /** Dynamic: Link to an existing web URL and bring traffic online */
  WEBSITE = 'WEBSITE',

  /** Static: Link to an existing web URL and bring traffic online */
  WEBSITE_STATIC = 'WEBSITE_STATIC',

  SMART_LINK = 'SMART_LINK',

  /** Static: Build a mobile-friendly business card to network better */
  VCARD_STATIC = 'VCARD_STATIC',
  VCARD = 'VCARD',

  VEVENT_STATIC = 'VEVENT_STATIC',

  BITCOIN_STATIC = 'BITCOIN_STATIC',

  BANK_TRANSFER_UA = 'BANK_TRANSFER_UA',
  BANK_TRANSFER_UA_STATIC = 'BANK_TRANSFER_UA_STATIC',
  BANK_TRANSFER_EPC_STATIC = 'BANK_TRANSFER_EPC_STATIC',

  UPI_STATIC = 'UPI_STATIC',

  /** Dynamic: Link a PDF document and distribute it efficiently */
  PDF = 'PDF',

  /** Dynamic: Organize all your QR menus in one digital location */
  // RESTAURANT_MENU = 'RESTAURANT_MENU',

  /** Dynamic: Design a form and get responses through scans */
  // FORM = 'FORM',

  /** Dynamic: Link to your social media channels for more engagement */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',

  /** Dynamic: Build a mobile-optimized webpage to interact with your audience */
  // LANDING_PAGE = 'landing_page',

  /** Dynamic: Redirect to app download or in-app pages for Android and iOS users */
  MOBILE_APP = 'MOBILE_APP',

  /** Dynamic: Point to any location on Google Maps */
  LOCATION = 'LOCATION',

  /** Dynamic: Route to a page displaying coupon code details */
  // COUPON_CODE = 'COUPON_CODE',

  /** Dynamic: Show a specific website URL based on the scanner’s country */
  // GEOLOCATION_REDIRECT = 'GEOLOCATION_REDIRECT',

  /** Dynamic: Link to a page containing your business details */
  // BUSINESS_PAGE = 'BUSINESS_PAGE',

  /** Dynamic: Show a photo */
  // IMAGE = 'IMAGE',
  /** Dynamic: Show a series of photos */
  IMAGE_GALLERY = 'IMAGE_GALLERY',

  /** Dynamic: Play an audio file */
  // AUDIO_MP3 = 'AUDIO_MP3',

  /** Static: Link to receive email messages */
  EMAIL_STATIC = 'EMAIL_STATIC',

  /** Dynamic: Link to receive email messages */
  EMAIL = 'EMAIL',

  /** Dynamic: Link to your phone number for quick calls */
  PHONE_CALL = 'PHONE_CALL',

  /** Static: Link to your phone number for quick calls */
  PHONE_CALL_STATIC = 'PHONE_CALL_STATIC',

  /** Dynamic: Redirect to your mobile number to receive SMS */
  SMS = 'SMS',

  /** Static: Redirect to your mobile number to receive SMS */
  SMS_STATIC = 'SMS_STATIC',

  /** Static: Display a short message */
  PLAIN_TEXT_STATIC = 'PLAIN_TEXT_STATIC',

  /** Static: Connect to a Wi-Fi network */
  WIFI_CONNECTION_STATIC = 'WIFI_CONNECTION_STATIC',
  FACEBOOK = 'FACEBOOK',
  FACEBOOK_STATIC = 'FACEBOOK_STATIC',

  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_STATIC = 'INSTAGRAM_STATIC',

  TIKTOK = 'TIKTOK',
  TIKTOK_STATIC = 'TIKTOK_STATIC',

  YOUTUBE = 'YOUTUBE',
  YOUTUBE_STATIC = 'YOUTUBE_STATIC',

  TWITTER = 'TWITTER',
  TWITTER_STATIC = 'TWITTER_STATIC',

  LINKEDIN = 'LINKEDIN',
  LINKEDIN_STATIC = 'LINKEDIN_STATIC',

  WHATSAPP = 'WHATSAPP',
  WHATSAPP_STATIC = 'WHATSAPP_STATIC',

  TELEGRAM = 'TELEGRAM',
  TELEGRAM_STATIC = 'TELEGRAM_STATIC',

  VIBER = 'VIBER',
  VIBER_STATIC = 'VIBER_STATIC',

  // SIGNAL_STATIC = 'SIGNAL_STATIC',
  // VIBER_STATIC = 'VIBER_STATIC',
  // ZOOM_STATIC = 'ZOOM_STATIC',
  // GOOGLE_MEE_STATIC = 'GOOGLE_MEE_STATIC',
  PAYPAL_STATIC = 'PAYPAL_STATIC',

  PIX_STATIC = 'PIX_STATIC',
}

// export type TQrCodeKind = (typeof EQrCodeKind)[keyof typeof EQrCodeKind];
// export type TQrCodeKindLower = Lowercase<TQrCodeKind>;
